import {match} from 'ts-pattern';

import {OnlineOfferAlternative} from '../api/types/onlineOfferAlternativesTypes';
import {translateWithFallback as t} from './translateWithFallback';

/** Why the customer cannot select an alternative, or `null` when they can. */
export const getAlternativeUnavailableReason = (
  alternative: Pick<OnlineOfferAlternative, 'unavailableReason' | 'selectable'>
) =>
  match(alternative.unavailableReason)
    .with('EXPIRED', () =>
      t(
        'alternatives.unavailable.expired',
        'This offer has expired. Ask your adviser for an updated offer.'
      )
    )
    .with('SOURCE_UNAVAILABLE', 'OFFERED_ELSEWHERE', () =>
      t(
        'alternatives.unavailable.vehicle',
        'This vehicle is no longer available. Select another alternative.'
      )
    )
    .with('PRICE_MISSING', () =>
      t(
        'alternatives.unavailable.priceMissing',
        'The price of this vehicle is being updated. Contact your adviser for the current price.'
      )
    )
    .with('SOURCE_CHANGED', 'PRICE_EXPIRED', () =>
      t('alternatives.unavailable.updating', 'Your adviser is updating this alternative.')
    )
    .with(null, () =>
      alternative.selectable
        ? null
        : t('alternatives.unavailable.generic', 'This alternative cannot be selected.')
    )
    .exhaustive();
